module.exports = __webpack_public_path__ + "static/media/tibcojasper.f3c6e17b.svg";